import React, { useState, useEffect } from "react";
import { Coffee, Lock } from "feather-icons-react/build/IconComponents";
import { base_api_url } from "../../../environment.jsx";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSearchParams } from "react-router-dom";
import PropTypes from "prop-types";

const CuisineAuth = ({ onAuthSuccess }) => {
  const [showModal, setShowModal] = useState(false);
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const MySwal = withReactContent(Swal);

  useEffect(() => {
    checkCuisinierAuth();
  }, []);

  const checkCuisinierAuth = () => {
    const cuisinierActif = localStorage.getItem("cuisinier_actif");
    if (!cuisinierActif) {
      setShowModal(true);
    } else {
      try {
        const cuisinier = JSON.parse(cuisinierActif);
        if (cuisinier && cuisinier.access_token) {
          onAuthSuccess();
        } else {
          setShowModal(true);
        }
      } catch (error) {
        console.error("Erreur parsing cuisinier_actif:", error);
        localStorage.removeItem("cuisinier_actif");
        setShowModal(true);
      }
    }
  };

  const handleAuth = async (e) => {
    e.preventDefault();
    
    if (!code.trim()) {
      MySwal.fire({
        icon: "error",
        // title: "Code requis",
        text: "Veuillez saisir votre code d'accès cuisine.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
                    customClass: { popup: "pixel-toast" }
});
      return;
    }

    const idRestaurant = searchParams.get("id_restaurant");
    if (!idRestaurant) {
      MySwal.fire({
        icon: "error",
        // title: "Restaurant manquant",
        text: "L'ID du restaurant est requis dans l'URL.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
                    customClass: { popup: "pixel-toast" }
});
      return;
    }

    setLoading(true);
    try {
      const payload = {
        code: code.trim(),
        id_restaurant: parseInt(idRestaurant)
      };

      const response = await axios.post(`${base_api_url}api/cuisine/restaurant`, payload);

      if (response.status === 200 || response.status === 201) {
        // Sauvegarder les infos du cuisinier
        localStorage.setItem("cuisinier_actif", JSON.stringify(response.data));
        
        MySwal.fire({
          icon: "success",
          // title: "Connexion réussie !",
          text: `Bienvenue ${response.data.nom_cuisinier}`,
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
                    customClass: { popup: "pixel-toast" }
});

        setShowModal(false);
        setCode("");
        onAuthSuccess();
      }
    } catch (error) {
      console.error("Erreur authentification cuisinier:", error);
      
//       let errorTitle = "Erreur d'authentification";
      let errorMessage = "Code d'accès invalide.";
      
      if (error.response) {
        switch (error.response.status) {
          case 400:
            errorMessage = "Données invalides. Vérifiez votre code.";
            break;
          case 401:
            errorMessage = "Code d'accès incorrect ou expiré.";
            break;
          case 403:
            errorMessage = "Accès refusé. Votre compte cuisinier est peut-être désactivé.";
            break;
          case 404:
            errorMessage = "Code d'accès non trouvé ou restaurant invalide.";
            break;
          default:
            errorMessage = error.response.data?.message || errorMessage;
        }
      } else if (error.request) {
//         errorTitle = "Problème de connexion";
        errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
      }
      
      MySwal.fire({
        icon: "error",
        // title: errorTitle,
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
                    customClass: { popup: "pixel-toast" }
});
    } finally {
      setLoading(false);
    }
  };

  if (!showModal) {
    return null;
  }

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0 text-center">
            <div className="w-100">
              <div className="d-flex justify-content-center mb-3">
                <div className="bg-primary rounded-circle p-3">
                  <Coffee size={32} color="white" />
                </div>
              </div>
              <h4 className="modal-title text-center">Accès Cuisine</h4>
              <p className="text-muted">Veuillez saisir votre code d&#39;accès pour continuer</p>
            </div>
          </div>
          
          <div className="modal-body">
            <form onSubmit={handleAuth}>
              <div className="form-group mb-4">
                <label htmlFor="code" className="form-label">
                  <Lock size={16} className="me-2" />
                  Code d&#39;accès cuisine
                </label>
                <input
                  type="text"
                  id="code"
                  className="form-control form-control-lg text-center"
                  placeholder="Entrez votre code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                  disabled={loading}
                  style={{ letterSpacing: '2px', fontSize: '18px' }}
                  autoFocus
                />
              </div>
              
              <button 
                type="submit" 
                className="btn btn-primary btn-lg w-100"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Vérification...
                  </>
                ) : (
                  <>
                    <Coffee size={16} className="me-2" />
                    Se connecter
                  </>
                )}
              </button>
            </form>
          </div>
          
          <div className="modal-footer border-0 justify-content-center">
            <small className="text-muted">
              Contactez votre responsable si vous n&#39;avez pas votre code d&#39;accès
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};
CuisineAuth.propTypes = {
  onAuthSuccess: PropTypes.func.isRequired,
};

export default CuisineAuth;